<div
  class="toast-wrapper simple-toast"
  (dblclick)="onOverlayClicked($event)"
  [@fadeInOut]="{
    value: fadeInOutAnimation,
    params: {
      closeDelay: toastNotificationBelonging.toastCoreConfig.animationOut === disappearanceAnimation.NONE ? '200ms' : '300ms'
    }
  }">
  <div
    [@.disabled]="
      toastNotificationBelonging.toastCoreConfig.animationIn === appearanceAnimation.NONE &&
      toastNotificationBelonging.toastCoreConfig.animationOut === disappearanceAnimation.NONE
    "
    [@boxAnimations]="boxAnimation"
    (mouseover)="mouseOver()"
    (mouseout)="mouseOut()"
    (click)="onToastClicked($event)"
    [className]="layoutHelper.getBoxClasses(toastNotificationBelonging.toastCoreConfig.layoutType, 'evolve-toast')">
    <div class="toast-title-content" #elTitleWrapper *ngIf="toastNotificationBelonging.dispatch.title">
      <div class="icon-section" *ngIf="!toastNotificationBelonging.toastCoreConfig.disableIcon">
        <span [className]="getIconClasses()"></span>
      </div>
      <div class="dont-break-out">
        <div class="text-wrapper dont-break-out">
          {{ toastNotificationBelonging.dispatch.title }}
          <span class="close-ico icon-times-circle" (click)="closeIcon()" *ngIf="!buttonsExist"></span>
        </div>
      </div>
    </div>

    <div class="content-holder toast-text" #elTextWrapper *ngIf="toastNotificationBelonging.dispatch.message">
      <div
        class="text-wrapper-section toast-inner-content"
        [ngStyle]="{
          'text-align': toastNotificationBelonging.toastCoreConfig.textPosition
        }"
        [ngClass]="{
          'only-message': !toastNotificationBelonging.dispatch.title
        }">
        <div class="dont-break-out">
          <div class="text-wrapper dont-break-out" *ngIf="!toastNotificationBelonging.toastCoreConfig.allowHtmlMessage">
            <p>{{ toastNotificationBelonging.dispatch.message }}</p>
          </div>
          <div
            class="text-wrapper"
            *ngIf="toastNotificationBelonging.toastCoreConfig.allowHtmlMessage"
            [innerHTML]="toastNotificationBelonging.dispatch.message"></div>
        </div>
      </div>
      <span
        class="close-ico icon-times-circle"
        (click)="closeIcon()"
        *ngIf="buttonsExist && !toastNotificationBelonging.dispatch.title"></span>
    </div>

    <div class="button-holder" #elButtonWrapper>
      <div
        class="button-section"
        *ngIf="toastNotificationBelonging.buttons.length"
        [ngStyle]="{
          'text-align': toastNotificationBelonging.toastCoreConfig.buttonPosition
        }">
        <button
          #elButton
          *ngFor="let button of toastNotificationBelonging.buttons"
          (click)="onCustomButton(button)"
          [className]="layoutHelper.getButtonClasses(button.layoutType, 'ed-btn ed-btn-sm')">
          {{ button.label }}
        </button>
      </div>

      <div
        class="button-section"
        [ngStyle]="{
          'text-align': toastNotificationBelonging.toastCoreConfig.buttonPosition
        }"
        *ngIf="
          !toastNotificationBelonging.buttons.length &&
          (toastNotificationBelonging.toastCoreConfig.declineLabel || toastNotificationBelonging.toastCoreConfig.confirmLabel)
        ">
        <button
          *ngIf="toastNotificationBelonging.toastCoreConfig.confirmLabel"
          (click)="onButtonClick('confirm')"
          [className]="
            layoutHelper.getButtonClasses(toastNotificationBelonging.toastCoreConfig.layoutType, 'ed-btn ed-btn-sm', 'auto-button')
          ">
          {{ toastNotificationBelonging.toastCoreConfig.confirmLabel }}
        </button>
        <button
          class="ed-btn ed-btn-sm ed-btn-secondary"
          (click)="onButtonClick('decline')"
          *ngIf="toastNotificationBelonging.toastCoreConfig.declineLabel">
          {{ toastNotificationBelonging.toastCoreConfig.declineLabel }}
        </button>
      </div>
    </div>

    <div class="progress-bar-container" *ngIf="!buttonsExist && toastNotificationBelonging.toastCoreConfig.progressBar !== 0">
      <div
        class="progress-bar"
        [ngStyle]="{
          width: (toastNotificationBelonging.toastCoreConfig.progressBar === 1 ? timer.Progress : timer.Remaining) + '%'
        }"></div>
    </div>
  </div>
</div>
